import React, { useState, useEffect } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate, useLocation } from "react-router-dom";

function Intakequota() {
    const formattedTitle = useLocation().pathname
        .split('/').pop()
        .replace(/-/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());
    const navigate = useNavigate();
    const [expandedRow, setExpandedRow] = useState(null);
    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };
    return (
        <>
            <div className="container-scroller">
                <Navbar />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <div className="main-panel">
                        <div className="content-wrapper">
                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <section className="content-header">
                                        <h1><i className="fa fa-university" />&nbsp;All School Intake Lists
                                        </h1>
                                        <ol className="breadcrumb">
                                            <li>
                                                <a onClick={() => navigate("/admin-dashboard")} style={{ cursor: "pointer" }}>
                                                    <i className="fa fa-tachometer" style={{ marginRight: "5px" }}></i> Home
                                                </a>
                                            </li>
                                            <li className="active">{formattedTitle}</li>
                                        </ol>
                                        <h3 />
                                    </section>
                                </div>
                            </div>
                            <div className="row">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>Select District</label>
                                                    <select className="form-select form-select-xs">
                                                        <option>Select</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>Select Block</label>
                                                    <select className="form-select form-select-xs">
                                                        <option>Select</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label>Active/Inactive</label>
                                                    <select className="form-select form-select-xs">
                                                        <option>Select</option>
                                                        <option>Active</option>
                                                        <option>Inactive</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-1">
                                                <div className="form-group">
                                                    <label>&nbsp;</label><br />
                                                    <button className="btn btn-success">Search</button>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="row">
                                            <div className="table-responsive">
                                                <table className="table table-bordered" style={{ width: '100%' }}>
                                                    <thead>
                                                        <tr className="table-primary">
                                                            <th></th>
                                                            <th>Sl. No</th>
                                                            <th>Block</th>
                                                            <th>School Name</th>
                                                            <th>School Address</th>
                                                            <th>Total Intake Quota</th>
                                                            <th>Principal's Name</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* Main Row */}
                                                        <tr>
                                                            <td className="text-center">
                                                                <button className="btn btn-link" onClick={() => toggleRow(1)}>
                                                                    <i className={`fa ${expandedRow === 1 ? 'fa-minus' : 'fa-plus'}`}></i>
                                                                </button>
                                                            </td>
                                                            <td>1</td>
                                                            <td>Bahadurpur</td>
                                                            <td>Chinchuria Upendranath High School</td>
                                                            <td>Chinchuria, Paschim Bardhaman, West Bengal, 713378</td>
                                                            <td>120</td>
                                                            <td>Mr. Priyobrata Banerjee</td>
                                                            <td><span className="badge bg-success">Active</span></td>
                                                            <td>
                                                                <a className="btn btn-primary" onClick={() => navigate("/view-school-details")}>
                                                                    <i className="fa fa-eye" /> View
                                                                </a>
                                                            </td>
                                                        </tr>

                                                        {/* Child Row */}
                                                        {expandedRow === 1 && (
                                                            <tr>
                                                                <td colSpan="9">
                                                                    <table className="childTable table table-condensed table-bordered">
                                                                        <thead>
                                                                            <tr className="table-success">
                                                                                <th>Sl. No</th>
                                                                                <th>Class</th>
                                                                                <th>Stream</th>
                                                                                <th>Allocated Students</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr><td>1</td><td>Class IX</td><td>All</td><td>80</td></tr>
                                                                            <tr><td>2</td><td>Class X</td><td>All</td><td>80</td></tr>
                                                                            <tr><td>3</td><td>Class XI</td><td>Arts</td><td>30</td></tr>
                                                                            <tr><td>4</td><td>Class XI</td><td>Science</td><td>20</td></tr>
                                                                            <tr><td>5</td><td>Class XI</td><td>Commerce</td><td>20</td></tr>
                                                                            <tr><td>6</td><td>Class XII</td><td>Arts</td><td>30</td></tr>
                                                                            <tr><td>7</td><td>Class XII</td><td>Science</td><td>20</td></tr>
                                                                            <tr><td>8</td><td>Class XII</td><td>Commerce</td><td>20</td></tr>
                                                                        </tbody>
                                                                        <tfoot>
                                                                            <tr>
                                                                                <td colSpan={4} style={{ textAlign: 'right' }}>
                                                                                    <button type="button" className="btn btn-sm btn-success" onClick={() => navigate("/intake-quota-allocation")}>
                                                                                        <i className="fa fa-edit" /> Edit Intake Quota
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        </tfoot>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Intakequota